import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { CLIENT_ID, SET_PASSWORD_PATH, DISCOVERY_DOCUMENT_LINK } from '../helpers/constants';
import GoogleIcon from './icons/GoogleIcon';

const SetPasswordGoogleButton = ({ className, email, token }) => {
  const [authURI, setAuthURI] = useState(null);
  const [authorizationEndpoint, setAuthorizationEndpoint] = useState(null);

  useEffect(() => {
    const fetchDiscovery = async () => {
      if (authorizationEndpoint) return;
      try {
        const responseJSON = await (await fetch(DISCOVERY_DOCUMENT_LINK)).json();
        setAuthorizationEndpoint(responseJSON['authorization_endpoint']);
      } catch (err) {
        console.error(err);
      }
    };
    fetchDiscovery();
  }, [authorizationEndpoint]);

  useEffect(() => {
    async function createAuthURI() {
      if (!email || !token || !authorizationEndpoint) return;

      // Encode email and token directly into the OAuth state parameter
      const statePayload = encodeURIComponent(JSON.stringify({ email, token }));

      // Use fixed redirect URI without query parameters (email/token are in state)
      const redirectUri = SET_PASSWORD_PATH;

      const gauthUrl =
        authorizationEndpoint +
        '?client_id=' +
        CLIENT_ID +
        '&response_type=code&scope=openid email&state=' +
        statePayload +
        '&redirect_uri=' +
        encodeURIComponent(redirectUri);
      setAuthURI(gauthUrl);
    }
    createAuthURI();
  }, [email, token, authorizationEndpoint]);

  return (
    <a href={authURI}>
      <Button className={className} variant="info" style={{ width: '100%' }}>
        <GoogleIcon />
        <span className="ml-2">Sign In With Google</span>
      </Button>
    </a>
  );
};

export default SetPasswordGoogleButton;
